import type { GetProjectsType } from './getProjectsType';
import type { GetProjectsStatus } from './getProjectsStatus';
import type { GetProjectsSortBy } from './getProjectsSortBy';
import type { GetProjectsSortDirection } from './getProjectsSortDirection';

export type GetProjectsParams = {
/**
 * 검색어 (제목, 설명에서 검색)
 */
query?: string;
/**
 * 프로젝트 목록 조회 관점/맥락
- FOR_YOU: 추천 또는 사용자 관련 프로젝트
- USER: 특정 사용자 프로젝트 (userId 파라미터 필요)
- FOLLOW: 팔로우하는 사용자의 프로젝트
- DETAIL: (사용처 확인 필요, 특정 상세 조회용?)
# 참고: 이전 정의는 프로젝트 종류(GAME, APP 등)였음.

 */
type?: GetProjectsType;
/**
 * 프로젝트 상태
- ALL: 모든 프로젝트
- PUBLISHED: 공개된 프로젝트
- DRAFT: 임시저장 프로젝트

 */
status?: GetProjectsStatus;
/**
 * 특정 사용자의 프로젝트를 조회할 때 사용하는 사용자 ID
 */
userId?: number;
/**
 * 태그로 필터링 (선택 사항)
 */
tag?: string;
/**
 * 조회 시작 날짜 (ISO 8601 형식, 선택 사항)
 */
startDate?: string;
/**
 * 조회 종료 날짜 (ISO 8601 형식, 선택 사항)
 */
endDate?: string;
/**
 * 정렬 기준 필드
 */
sortBy?: GetProjectsSortBy;
/**
 * 정렬 방향
 */
sortDirection?: GetProjectsSortDirection;
/**
 * 페이지 번호 (0부터 시작)
 */
page?: number;
/**
 * 페이지 크기
 */
size?: number;
};
